module.exports = __webpack_public_path__ + "static/img/tj001.09243fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj001.png
// module id = eMPb
// module chunks = 3